const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the User Manager Directive to display a list or table with users to manage
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Users the resource defined to get and set User data
 */
app.directive('suspendedManager', ['Application', 'AdminUsers', 'Users', 'AccessHelper', function (Application, AdminUsers, Users, AccessHelper) {
    return {
      restrict: 'E',
      scope: {
        refresh: '=',
        callRefresh: '&'
      },
      replace: true,
      template: require('../../templates/directives/suspended-manager.html'),
      controller: ['$scope', '$translate', function ($scope, $translate) {
          var self = this;

          self.allowance = {
            add: AccessHelper.isAllowed(['admin', 'users', 'add'], null, ['admin']),
            edit: AccessHelper.isAllowed(['admin', 'users', 'edit'], null, ['admin']),
            view: AccessHelper.isAllowed(['admin', 'users', 'view'], null, ['admin']),
            suspend: AccessHelper.isAllowed(['admin', 'users', 'suspend'], null, ['admin']),
            password_reset: AccessHelper.isAllowed(['admin', 'users', 'password_reset'], null, ['admin'])
          };

          if (!self.allowance.view) {
            Application.navigation.goTo('/explore');
            return;
          }

          self.data = {
            nextAvailable: false,
            loading: false,
            list: [],
            standardQuery: function() {
              return {
                page: 1,
                per_page: 15,
                suspended: true
              };
            },
            query: {
              page: 1,
              per_page: 15,
              suspended: true,
              sort: "suspended_on,-1"
            },
            get: function() {
              this.loading = true;
              return AdminUsers.find(this.query).$promise
              .then(function(users) {
                self.data.loading = false;
                self.data.nextAvailable = false;
                if (users && users.length >= self.data.query.per_page) {
                  self.data.nextAvailable = true;
                }
                self.data.list = users;
              }).catch(function(error) {

              });
            },
            next: function() {
              if (!this.nextAvailable) {
                return;
              }
              this.query.page++;
              this.get();
            },
            previous: function() {
              if (this.query.page <= 1) {
                return;
              }
              this.query.page--;
              this.get();
            }
          };

          self.selections = {
            confirm: false,
            list: [],
            directory: {},
            select: function(id, user) {
              this.directory[id] = user;
              var index = this.list.indexOf(id);
              if (index === -1) {
                this.list.push(id);
                return;
              }
              this.list.splice(index, 1);
            },
            reinstate: function() {
              self.data.loading = true;
              Users.unsuspend({}, {users: this.list}).$promise
              .then(function(results) {
                for (var i = self.data.list.length - 1; i >= 0; i--) {
                  if (self.data.list[i]._id && self.selections.list.indexOf(self.data.list[i]._id) !== -1) {
                    self.data.list.splice(i, 1);
                  }
                }
                self.selections.list = [];
                self.selections.directory = {};
                self.selections.confirm = false;
                self.data.loading = false;
                $scope.callRefresh({type: 'suspended'});
                Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['suspendManager.all_reinstated_success']});
              }).catch(function(error) {
                self.selections.confirm = false;
                self.data.loading = false;
                if (error.data && error.data.message && error.data.message === 'User limit has been reached.') {
                  Application.messaging.addMessage({type: 'error', duration: 7, text: self.translations['suspendManager.user_limit_reached']});
                  return;
                }
                Application.messaging.addMessage({type: 'error', duration: 7, text: self.translations['suspendManager.error_has_occurred']});
              });
            }
          };

          self.search = {
            active: false,
            placeholder: 'Search by users name',
            optionRestrictions: {
              departments: true,
              locations: true,
              skills: true
            },
            newFilter: function(opts) {
              this.active = false;
              self.data.query = self.data.standardQuery();
              if (!opts) {
                self.data.get();
                return;
              }
              this.active = true;
              for (var key in opts) {
                self.data.query[key] = opts[key];
              }
              self.data.get();
            }
          };

          self.initialize = function() {
            self.data.get();
          };

          $scope.$watch('refresh', function(newVal, oldVal) {
            if (newVal && !oldVal) {
              self.data.get();
              $scope.refresh = false;
            }
          });

          $translate(['modules.notifications.users_wereDeleted',
          'suspendManager.all_reinstated_success',
          'suspendManager.user_limit_reached',
          'suspendManager.error_has_occurred'
          ]).then(function(data){
            self.translations = data;
            self.initialize();
          });

        }],
      controllerAs: 'suspended'
    };
  }]);